export default __webpack_public_path__ + "locales/ru/ChangeUserStatusDialog.json?hash=81ecbf7145afd91f39c350a781d93031";